<template>
    <div class="wechat_management_wrap">

        <div class="wechat_management_bottom" v-loading="loading">
            <CustomVxeTable
                    ref="tableRef"
                    class="custom-table"
                    id="wxChatRoleTable"
                    :tableData="tableData"
                    :reduceHeight="reduceHeight"
                    :isShowToolBar="true"
                    :empty-render="{ name: 'NotData' }"
                    :pagination.sync="pagination"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    :customConfig="tableCustomConfig">

                <vxe-column field="ticket_name" title="管理员"  width="180" show-overflow></vxe-column>
                <vxe-column field="name3" title="描述"  min-width="180" show-overflow></vxe-column>

                <vxe-column field="name3" title="关联人员"  width="382" show-overflow>
                    <template #default="{ row }">
                        <userDetailPopover v-if="row.create_user && row.create_user.id" :uid="row.create_user.id">
                            <div slot="container">
                             <span v-text="(row.create_user && row.create_user.name) ? row.create_user.name : '-'"></span>
                            </div>
                        </userDetailPopover>
                    </template>
                </vxe-column>
                <vxe-column field="operate" width="90" fixed="right">
                    <template #header>
                        <span>操作</span>
                        <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                            <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                        </el-tooltip>
                    </template>
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <el-button type="text" @click="handleClickAuth(row)">授权</el-button>
                        </div>
                    </template>
                </vxe-column>

            </CustomVxeTable>
        </div>


        <userDepartmentSelection :userDepartmentVisible.sync="userDepartmentVisible" v-if="userDepartmentVisible" :userDepartmentSelected="userDepartmentSelected" :type="'user'" :userDepartmentTitle="'授权人员'"  @success="userDepartmentSuccess"/>


    </div>
</template>
<script>
import { ticketList,ticketDel,ticketSort} from "@/api/index.js"
import {pagination} from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import userDepartmentSelection from "@/components/pComponents/userDepartmentSelection.vue";
import Sortable from "sortablejs";
export default {
    name: 'WeChatRole',
    components: {
        CustomVxeTable,
        userDepartmentSelection,
        userDetailPopover
    },
    data () {
        return {
            loading:false,
            keywords:'',
            tableData:[
                {id:1}
            ],
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "id";
                },
                allowSort: true,
            },
            userDepartmentSelected:[],
            userDepartmentVisible:false

        }
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return  this.tableData.length ? 132 : 76;
        },
    },
    mounted () {
        this.getTableData()

    },
    methods: {


        // 授权
        handleClickAuth(row){
            this.userDepartmentVisible = true
        },

        userDepartmentSuccess(data){
            console.log(data);
        },


        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        getTableData(){
            let postData = {
                page: this.pagination.page,
                pageSize: this.pagination.pageSize,

            }
           //  this.loading = true
           //  ticketList(postData).then(res=> {
           //     if(res.code === 200) {
           //         let {data,total} = res.data
           //         this.tableData = data
           //         this.pagination.total = total
           //     }
           //     this.loading = false
           // })

        },
    },

}
</script>

<style lang="scss" scoped>
@import "@/styles/wechat.scss";
.wechat_management_bottom{
    margin-top: 16px;
}
</style>
